import { parseISO, isValid, startOfDay, format } from 'date-fns';

/** Parse string/Date to Date. Returns null for falsy, invalid, or year<=1 (C# default "unset") values.
 *  Handles ISO 8601 and DD.MM.YYYY formats. Does not normalize time — callers handle that. */
export const toDate = (value: unknown): Date | null => {
  if (!value) return null;
  let date: Date | null = null;
  if (typeof value === 'string') {
    date = parseISO(value);
    // Fallback: DD.MM.YYYY (e.g. from OCR analysis results)
    if (!isValid(date) && /^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
      const [day, month, year] = value.split('.').map(Number);
      date = new Date(year, month - 1, day);
    }
  } else if (value instanceof Date) {
    date = value;
  }
  return date && isValid(date) && date.getFullYear() > 1 ? date : null;
};

export const isValidDate = (value: unknown): boolean => toDate(value) !== null;

export const formatDate = (value: unknown): string | null => {
  const date = toDate(value);
  return date ? format(date, 'dd.MM.yyyy') : null;
};

/** ISO string normalized to midnight — matches SingleDatePicker onChange format. */
export const toISODateString = (value: unknown): string | undefined => {
  const date = toDate(value);
  return date ? format(startOfDay(date), "yyyy-MM-dd'T'HH:mm:ss") : undefined;
};

export const toApiDateUTC = (value: unknown): Date | null => {
  const date = toDate(value);
  return date
    ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
    : null;
};
